import MaintenanceCard from "./MaintenanceCard"

export default  MaintenanceCard;
